import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { ListCardComponent } from '../list-card/list-card.component';

@Component({
    selector: 'app-products-list-view',
    templateUrl: './products-list-view.component.html',
    styleUrls: ['./products-list-view.component.scss'],
    imports: [NgIf, NgFor, ListCardComponent]
})
export class ProductsListViewComponent implements OnInit, OnChanges {
  @Input() item: any;
  @Input() index: number;
  @Input() browseType: any;

  constructor() { }

  ngOnChanges(): any{

  }

  ngOnInit(): void {

}

}
